import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-apply-button',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './apply-button.component.html',
  styleUrls: ['./apply-button.component.scss']
})
export class ApplyButtonComponent {
  @Input() defaultText: string = 'Bin ich geeignet?';
  @Input() hoverText: string = 'Let\'s go 🚀';
  @Input() placesCount: number = 86;
  @Input() totalPlaces: number = 90;
  @Input() targetUrl: string = 'https://go.horizonnet-consulting.at/analyse';
  @Input() darkCounter: boolean = false;

  navigate(): void {
    window.open(this.targetUrl, '_blank');
  }
} 